import moment from 'jalali-moment'
import React from 'react'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
interface IItemProps {
    amount: number
    name: string
    type: string
    date: string
    destination: string
}
export default function Item({
    amount,
    name,
    date,
    type,
    destination,
}: IItemProps) {
    return (
        <div className=" bg-white mb-2 px-2 py-2 flex justify-between">
            <div>
                {destination === 'hwt' ? (
                    <p>شارژ کیف پول</p>
                ) : destination === 'bba' ? (
                    <p>صندوق {name}</p>
                ) : destination === 'hbb' ? (
                    <p>صندوق {name}</p>
                ) : destination === 'hpl' ? (
                    <p>ارتفاء صندوق</p>
                ) : destination === 'mba' ? (
                    <p>صندوق {name}</p>
                ) : (
                    <p></p>
                )}
                <p className=" text-sm text-gray-1">
                    {MoneyPoolTransactionTypes[type]}
                </p>
            </div>
            <div>
                <p className=" text-sm text-gray-1">
                    {date &&
                        moment
                            .from(date, 'en', 'YYYY-MM-DD HH:mm:ss')
                            .locale('fa')
                            .format('YYYY/MM/DD HH:mm:ss')}
                </p>
                {destination === 'mba' ? (
                    <p className=" text-left text-error-3">
                        {amount && amount.toLocaleString()} تومان <span> </span>
                    </p>
                ) : (
                    <p className=" text-left text-green-1">
                        {amount && amount.toLocaleString()} تومان <span> </span>
                    </p>
                )}
            </div>
        </div>
    )
}
